import * as React from 'react';

import uiSection from '@belong/ui-sections/sections/sectionPlanSummary';
import { useRouter } from 'next/router';
import { withoutBasePath } from '@belong/url-utils';

const { view: UISection } = uiSection;

const View = props => {
  const router = useRouter();

  const handlePlanChosen = selectedPlan => {
    router.push(withoutBasePath(selectedPlan.ctaUrl.href, router.basePath));
  };

  return <UISection {...props} onClickCTA={handlePlanChosen} />;
};

export default View;
